import { useState, useEffect } from "react";
import { useEthers } from "@usedapp/core";
import { Button, Modal, Loader } from "@mantine/core";
import { useStopCampaign } from "../hooks/useStopCampaign";
import { useFormik } from "formik";
const StopCampaignModal = ({
  campaign,
  opened,
  setOpened,
  campaignAddrArray,
  campaignType,
  expectedChain,
  showStopPrompt,
  setShowStopPrompt,
}) => {
  const closeModal = () => {
    setSuccessStop(false);
    setErrorStop(false);
    setOpened(false);
    setVisible(true);
  };
  const { chainId, switchNetwork } = useEthers();
  const [frozenModal, setFrozenModal] = useState(true);
  const [loadingPrompt, setLoadingPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const switchNet = () => {
    switchNetwork(expectedChain?.chainId);
  };
  const customLoader = (
    <div className="flex flex-col items-center">
      <Loader color={"#ADB5FF"} />
      <p className="mt-5">{loadingPrompt}</p>
    </div>
  );
  const campaignAddr = campaignAddrArray[0];
  const [stopCampaign, stopCampaignStatus] = useStopCampaign(
    campaignAddr,
    campaignType
  );
  // eslint-disable-next-line
  const [visible, setVisible] = useState(true);
  const [successStop, setSuccessStop] = useState(false);
  const [errorStop, setErrorStop] = useState(false);
  const formik = useFormik({
    initialValues: {
      campaignAddr: campaignAddr,
      campaignType: campaignType,
      expectedChain: expectedChain,
    },
    onSubmit: async (values, { setSubmitting }) => {
      if (campaign.isActive === true) {
        setSubmitting(true);
        setSuccessStop(false);
        setLoading(true);
        setErrorStop(false);
        setVisible(false);
        setShowStopPrompt(false);
        setFrozenModal(false);
        try {
          await stopCampaign(values);
          setFrozenModal(true);
          // closeModal();
        } catch (err) {
          console.log(err);
        }
        setSubmitting(false);
      } else {
        setErrorStop(true);
        setVisible(false);
        setShowStopPrompt(false);
      }
    },
  });

  useEffect(() => {
    if (stopCampaignStatus.status === "Exception") {
      setErrorStop(true);
      setLoading(false);
    } else {
      if (stopCampaignStatus.status === "Success") {
        setSuccessStop(true);
        setLoading(false);
      } else if (stopCampaignStatus.status === "Mining") {
        setLoadingPrompt("Stopping...");
      } else if (stopCampaignStatus.status === "PendingSignature") {
        setLoadingPrompt("Comfirming with Your Wallet...");
      }
    }
  }, [stopCampaignStatus, setLoadingPrompt, setSuccessStop]);

  return (
    <>
      <Modal
        opened={opened}
        closeOnClickOutside={frozenModal}
        withCloseButton={false}
        padding={"40px 60px"}
        centered={true}
        onClose={closeModal}
        styles={{
          modal: {
            textAlign: "center",
            borderColor: "#94949C",
            borderWidth: "1px",
          },
        }}
      >
        {/* <LoadingOverlay
          loader={customLoader}
          overlayOpacity={0.3}
          overlayColor="#ADB5FF"
          visible={visible}
        /> */}
        <div className={loading ? "flex flex-col" : "hidden flex-col"}>
          {customLoader}
        </div>
        <div className={successStop ? "flex flex-col" : "hidden flex-col"}>
          <p className="text-center">Campaign Stopped Successfully!</p>
          <Button
            className="btn-pri  mx-auto mt-10 mb-3 w-48 px-12 hover:bg-bgv2"
            onClick={closeModal}
          >
            Close
          </Button>
        </div>
        <div className={errorStop ? "flex flex-col" : "hidden flex-col"}>
          <p className="text-center">Campaign Stopped Unsuccessfully!</p>
          <Button
            className=" btn-pri mx-auto mt-10 mb-3 w-48 px-12 hover:bg-bgv2"
            onClick={closeModal}
          >
            Close
          </Button>
        </div>
        <div
          className={showStopPrompt ? "flex flex-col " : " hidden flex-col "}
        >
          <div className=" text-md font-bold">
            Are you sure you want to stop this campaign
          </div>
          <div className="text-xs font-normal text-gray1">
            Once you stop this campaign, you won&apos;t be able to <br></br>
            re-start it and new users won&apos;t be able to claim it.
          </div>
          <div className="flex flex-row justify-around">
            <Button
              class="btn-pri w-content mt-5  bg-gray px-12 hover:bg-bgv2"
              onClick={closeModal}
            >
              No
            </Button>
            <form autoComplete="off" onSubmit={formik.handleSubmit}>
              {chainId !== expectedChain?.chainId ? (
                <Button class="btn-pri mt-5 px-12" onClick={switchNet}>
                  Switch to {expectedChain?.chainName} Network
                </Button>
              ) : (
                <Button class="btn-pri w-content mt-5 px-12" type="submit">
                  Yes
                </Button>
              )}
            </form>
          </div>
        </div>

        {/* <div>
          {successStop && (
            <div className=" text-green-400">
              <p>Campaign Stop Successfully</p>
            </div>
          )}
          {errorStop && (
            <div className=" text-red-400">
              <p>Campaign Stop Unsuccessfully</p>
            </div>
          )}
        </div> */}
      </Modal>
    </>
  );
};

export default StopCampaignModal;
